/** @format */

import * as React from "react";
import { Box, useDisclosure, useMediaQuery } from "@chakra-ui/react";
import theme from "@src/style/theme";
import colors from "@src/style/colors";

import Intro_KR from "./ko/0_Intro";
import Intro_EN from "./en/0_Intro";
import { useStores } from "@src/hooks/useStores";
import { observer } from "mobx-react";
import { Language } from "@src/stores/Settings";
import Partner_KR from "./ko/1_Partner";
import Strength_KR from "./ko/2_Strength";
import Feature_KR from "./ko/3_Feature";
import Value_KR from "./ko/4_Value";
import Message_KR from "./ko/5_Message";
import Growth_KR from "./ko/6_Growth";
import Review_KR from "./ko/7_Review";
import Safety_KR from "./ko/8_Safety";
import QnA_KR from "./ko/9_QnA";
import Download_KR from "./ko/10_Download";
import Partner_EN from "./en/1_Partner";
import Strength_EN from "./en/2_Strength";
import Feature_EN from "./en/3_Feature";
import Value_EN from "./en/4_Value";
import Message_EN from "./en/5_Message";
import Growth_EN from "./en/6_Growth";
import Review_EN from "./en/7_Review";
import Safety_EN from "./en/8_Safety";
import QnA_EN from "./en/9_QnA";
import Download_EN from "./en/10_Download";

export const Home: React.FC = observer(() => {
  const myRef = React.useRef(null);
  const { settings } = useStores();

  React.useEffect(() => {
    if (settings.isDirectingQnA) {
      settings.setDirectingQnA();
      myRef.current?.scrollIntoView({
        block: "center",
        inline: "nearest"
      });
    }
  }, [settings.isDirectingQnA]);

  return (
    <Box position={"static"} width="100%" bgColor={colors.white}>
      {settings.language == Language.korean ? (
        <>
          <Intro_KR />
          <Partner_KR />
          {/* <Strength_KR /> */}
          <Feature_KR />
          <Value_KR />
          {/* <Message_KR /> */}
          {/* <Growth_KR /> */}
          {/* <Review_KR /> */}
          <Safety_KR />
          <Box ref={myRef}>
            <QnA_KR />
          </Box>
          <Download_KR />
        </>
      ) : (
        <>
          <Intro_EN />
          <Partner_EN />
          {/* <Strength_EN /> */}
          <Feature_EN />
          <Value_EN />
          {/* <Message_EN /> */}
          {/* <Growth_EN /> */}
          {/* <Review_EN /> */}
          <Safety_EN />
          <Box ref={myRef}>
            <QnA_EN />
          </Box>
          <Download_EN />
        </>
      )}
    </Box>
  );
});

export default Home;
